export default {
  delContent2: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000DD8","删除") /* "删除" */,
  editContent2: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000DD9","编辑") /* "编辑" */,
  item: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000DDA","条") /* "条" */,
  operationSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000DDB","操作成功") /* "操作成功" */,
  batchContentA: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000DDC","是否要对选中的") /* "是否要对选中的" */,
  batchContentB: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000DDD","记录执行操作吗？") /* "记录执行操作吗？" */
};
